import defaultSettings from '../../global'

const title = defaultSettings.title || 'Vue Element Admin'

// 获取跳转路径，完成基础拼接
export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle} - ${title}`
    }
    return `${title}`
}
